(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ 22871:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms",
      function () {
        return __webpack_require__(36377);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ terms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./src/components/blocks/footer/index.ts + 21 modules
var footer = __webpack_require__(77702);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var NextLink = __webpack_require__(99472);
;// CONCATENATED MODULE: ./src/components/reuseable/Breadcrumb.tsx


// ========================================================
var breadcrumb = [
    {
        id: 1,
        title: "Home",
        url: "/"
    },
    {
        id: 2,
        title: "Shop",
        url: "/shop"
    }
];
var Breadcrumb = function(param) {
    var _data = param.data, data = _data === void 0 ? breadcrumb : _data, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "d-inline-block",
        "aria-label": "breadcrumb",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "breadcrumb ".concat(className),
            children: data.map(function(param, i) {
                var id = param.id, title = param.title, url = param.url;
                return data.length - 1 === i ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "breadcrumb-item active",
                    "aria-current": "page",
                    children: title
                }, id) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "breadcrumb-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        title: title,
                        href: url
                    })
                }, id);
            })
        })
    });
};
/* harmony default export */ var reuseable_Breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(74870);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
;// CONCATENATED MODULE: ./pages/terms.tsx





// -------- data -------- //


var linkList = [
    {
        id: 1,
        title: "1. Introduction",
        to: "introduction"
    },
    {
        id: 2,
        title: "2. Privacy Policy",
        to: "privacy-policy"
    },
    {
        id: 3,
        title: "3. Fees and Payment",
        to: "fees"
    },
    {
        id: 4,
        title: "4. Client Responsibilities",
        to: "client"
    },
    {
        id: 5,
        title: "5. Confidentiality",
        to: "confidentiality"
    },
    {
        id: 6,
        title: "6. Intellectual Property",
        to: "intellectual"
    },
    {
        id: 7,
        title: "7. Termination",
        to: "termination"
    },
    {
        id: 8,
        title: "8. Limitation of Liability",
        to: "limitation"
    },
    {
        id: 9,
        title: "9. Governing Law",
        to: "governing"
    },
    {
        id: 1,
        title: "10. Entire Agreement",
        to: "agreement"
    }
];
var terms_breadcrumb = [
    {
        id: 1,
        title: "Home",
        url: "/"
    },
    {
        id: 2,
        title: "Terms and Conditions",
        url: "/terms"
    }
];
var details = {
    pageName: "Terms and Conditions",
    categories: "Terms and Conditions",
    description: "Molto SEO terms and conditions.",
    parentDirectories: ""
};
var Terms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: details.pageName,
                description: details.description,
                tag: details.categories,
                url: "/terms}",
                image: "https://moltoseo.co.uk/img/logo/technical-seo-agency.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-soft-primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container pt-10 pb-12 pt-md-14 pb-md-16 text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-10 col-lg-8 col-xl-7 col-xxl-6 mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "display-1 mb-3",
                                                    children: "Terms and Conditions"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_Breadcrumb, {
                                                    data: terms_breadcrumb
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row gx-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                            className: "col-xl-3 sidebar sticky-sidebar mt-md-0 py-16 d-none d-xl-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    id: "sidebar-nav",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "list-unstyled text-reset",
                                                        children: linkList.map(function(param) {
                                                            var id = param.id, title = param.title, to = param.to;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                                                    smooth: true,
                                                                    spy: true,
                                                                    activeClass: "active",
                                                                    to: to,
                                                                    className: "nav-link",
                                                                    children: title
                                                                })
                                                            }, id);
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xl-8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "introduction",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "1. Introduction"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        "Welcome to",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://moltoseo.co.uk/",
                                                                            title: "MoltoTechnical SEO agency",
                                                                            children: "Molto SEO"
                                                                        }),
                                                                        ", a digital marketing agency that provides SEO, social media marketing, web design, and PPC services. By using our services, you agree to be bound by the following terms and conditions:"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "privacy-policy",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "2. Privacy Policy"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Scope of Services Molto SEO provides SEO, social media marketing, web design, and PPC services to its clients. The services are delivered in accordance with the package selected by the client. Molto SEO reserves the right to change the services or discontinue them at any time without prior notice."
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "fees",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Fees and Payment"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        "The fees for Molto SEO's services are specified in the package selected by the client. Payment is due in full before the start of the project. Molto SEO",
                                                                        " ",
                                                                        "reserves the right to suspend or terminate its services if payment is not received on time."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "client",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Client Responsibilities"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        "The client is responsible for providing accurate and complete information necessary for molto",
                                                                        " ",
                                                                        "SEO to deliver its services. The client also agrees to promptly review and approve all materials and deliverables provided by Molto SEO."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "confidentiality",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Confidentiality"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Molto SEO agrees to keep all client information confidential and not disclose it to any third party without the client's consent. The client agrees to keep confidential all Molto SEO's proprietary information, including trade secrets, and not disclose it to any third party without Molto SEO's consent."
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "intellectual",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Intellectual Property"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        "Molto SEO retains all rights to any intellectual property developed by molto",
                                                                        " ",
                                                                        "SEO in connection with the services provided to the client. The client agrees not to use, reproduce, distribute, or sell any intellectual property developed by molto",
                                                                        " ",
                                                                        "SEO without Molto SEO's consent."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "termination",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Termination"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        "Either party may terminate the agreement at any time for any reason upon written notice to the other party. Upon termination, the client agrees to pay all fees due to Molto SEO",
                                                                        " ",
                                                                        "for services rendered up to the date of termination."
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "limitation",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Limitation of Liability"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Molto SEO shall not be liable for any direct, indirect, special, incidental, or consequential damages arising out of or in connection with the services provided to the client, including but not limited to damages for lost profits, loss of data, or interruption of business, even if Molto SEO has been advised of the possibility of such damages."
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "governing",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Governing Law"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "This agreement shall be governed by and construed in accordance with the laws of England and Wales. Any disputes arising out of or in connection with this agreement shall be resolved by the courts of England and Wales."
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                                                    name: "agreement",
                                                    className: "wrapper pt-16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "card",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "card-body p-10",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "mb-3",
                                                                    children: "Entire Agreement"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "This agreement constitutes the entire agreement between Molto SEO and the client and supersedes all prior agreements and understandings, whether written or oral, relating to the subject matter of this agreement. By using Molto SEO's services, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions."
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "\xa0"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "\xa0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer1 */.gH, {
                        address: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    keywords.SiteIdentity[0].address1,
                                    ",",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    keywords.SiteIdentity[0].address2,
                                    ",",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    keywords.SiteIdentity[0].address3
                                ]
                            })
                        ],
                        email: keywords.SiteIdentity[0].email,
                        phone: keywords.SiteIdentity[0].phone
                    })
                ]
            })
        ]
    });
};
var List = function(param) {
    var data = param.data;
    return /*#__PURE__*/ _jsx("ul", {
        className: "icon-list bullet-bg bullet-soft-primary mb-0",
        children: data.map(function(item) {
            return /*#__PURE__*/ _jsxs("li", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "uil uil-check"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: item
                    })
                ]
            }, item);
        })
    });
};
/* harmony default export */ var terms = (Terms);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,4870,4556,9774,2888,179], function() { return __webpack_exec__(22871); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);